import React from 'react'
import styled from 'styled-components'

type DetailsProps = React.PropsWithChildren<{
  summary: (options: { isOpen: boolean }) => React.ReactNode
}>

export const Details = (props: DetailsProps) => {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <Root>
      <Summary type="button" onClick={() => setIsOpen((x) => !x)}>
        {props.summary({ isOpen })}
      </Summary>
      <Content $isOpen={isOpen}>
        <ContentExpander $isOpen={isOpen}>{props.children}</ContentExpander>
      </Content>
    </Root>
  )
}

const Root = styled.div``
const Summary = styled.button`
  all: unset;
  cursor: pointer;
  display: block;
  width: 100%;
`
const Content = styled.div<{ $isOpen: boolean }>`
  display: grid;
  grid-template-rows: ${(_) => (_.$isOpen ? '1' : '0')}fr;
  overflow: hidden;
  transition: grid-template-rows 0.3s;

  & > div {
    visibility: ${(_) => (_.$isOpen ? 'visible' : 'hidden')};
  }
`
const ContentExpander = styled.div<{ $isOpen: boolean }>`
  min-height: 0;
  transition: visibility 0.3s;
`
